module.exports = __webpack_public_path__ + "img/Product.243f4727.png";